
const state = () => ({
    list: []
});

const getters = {};

const actions = {};

const mutations = {
    add(state:IKeepAliveStoreState, name:string | Array<string>):void
    {
        if (typeof name === 'string')
        {
            !state.list.includes(name) && state.list.push(name);
        }
        else
        {
            name.map(v =>
            {
                v && !state.list.includes(v) && state.list.push(v);
            });
        }
    },
    remove(state:IKeepAliveStoreState, name:string | Array<string>):void
    {
        if (typeof name === 'string')
        {
            state.list = state.list.filter(v =>
            {
                return v != name;
            });
        }
        else
        {
            state.list = state.list.filter(v =>
            {
                return !name.includes(v);
            });
        }
    },
    clean(state:IKeepAliveStoreState):void
    {
        state.list = [];
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
